import React from "react";

function SectionHeader({ label }) {
  return (
    <div className="flex items-center mb-6">
      <div className="flex items-center text-cyan-400 font-mono text-xs uppercase tracking-wider">
        <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2 animate-pulse"></span>
        <span className="opacity-70">{label}</span>
      </div>
      <div className="flex-1 h-px bg-gradient-to-r from-cyan-400/30 to-transparent ml-4"></div>
    </div>
  );
}

export default React.memo(SectionHeader);
